import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import moment from 'moment';

import Loader from '../../../components/Common/Loader/Loader';
import CustomPagination from '../../../components/CustomPagination';
import { decode } from '../../../helpers/queryEncryption';

// Reusable admin list for the operational-alerts pages (unfulfilled / stalled bookings).
// Props: query (gql), dataKey (root field, e.g. 'getUnfulfilledBookings'), heading, emptyMsg.
const OperationalBookingsTable = ({ query, dataKey, heading, emptyMsg }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const { loading, data, refetch } = useQuery(query, {
    variables: { currentPage, searchList: '' },
    fetchPolicy: 'network-only',
    ssr: false,
  });

  const results = (data && data[dataKey] && data[dataKey].results) || [];
  const count = (data && data[dataKey] && data[dataKey].count) || 0;

  const paginationData = (page) => {
    setCurrentPage(page);
    refetch({ currentPage: page, searchList: '' });
  };

  const fmtDate = (v) => {
    if (!v) return '-';
    const n = Number(v);
    const m = Number.isFinite(n) ? moment(n) : moment(v);
    return m.isValid() ? m.format('DD-MM-YYYY HH:mm') : '-';
  };

  return (
    <Loader type={'page'} show={loading}>
      <h1 className="siteAdminPrimaryHeading">{heading}</h1>
      {!loading && (
        results.length === 0 ? (
          <p>{emptyMsg}</p>
        ) : (
          <>
            <table className="table" style={{ width: '100%' }}>
              <thead>
                <tr>
                  <th scope="col">Booking #</th>
                  <th scope="col">Client</th>
                  <th scope="col">Service</th>
                  <th scope="col">Location</th>
                  <th scope="col">Status</th>
                  <th scope="col">Created</th>
                </tr>
              </thead>
              <tbody>
                {results.map((item) => (
                  <tr key={item && item.id}>
                    <td data-label="Booking #">{item && item.id}</td>
                    <td data-label="Client">
                      {item && item.userDetails
                        ? `${decode(item.userDetails.encryptFirstName) || ''} ${decode(item.userDetails.encryptLastName) || ''}`.trim() || '-'
                        : '-'}
                    </td>
                    <td data-label="Service">{(item && item.categoryDetails && item.categoryDetails.name) || '-'}</td>
                    <td data-label="Location">{(item && item.userLocation) || '-'}</td>
                    <td data-label="Status">{item && item.status}</td>
                    <td data-label="Created">{fmtDate(item && item.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            {count > 10 && (
              <CustomPagination
                total={count}
                currentPage={currentPage}
                defaultCurrent={1}
                defaultPageSize={10}
                change={paginationData}
                paginationLabel="bookings"
              />
            )}
          </>
        )
      )}
    </Loader>
  );
};

export default OperationalBookingsTable;
